// Campus photo for /colleges/southern-methodist-university: Public domain, by Carol M. Highsmith, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ADallas_Hall_on_the_campus_of_Southern_Methodist_University%2C_Dallas%2C_Texas_LCCN2015630915.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/southern-methodist-university/; credited under the photo.
const photo = {
    "slug": "southern-methodist-university",
    "alt": "Dallas Hall at Southern Methodist University, a red brick building with white columns and a green copper dome, behind a lawn and a fountain at dusk",
    "src": "/colleges/southern-methodist-university/campus-1600.webp",
    "srcSmall": "/colleges/southern-methodist-university/campus-800.webp",
    "srcMid": "/colleges/southern-methodist-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/southern-methodist-university/og.jpg",
    "title": "Dallas Hall on the campus of Southern Methodist University, Dallas, Texas LCCN2015630915",
    "author": "Carol M. Highsmith",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ADallas_Hall_on_the_campus_of_Southern_Methodist_University%2C_Dallas%2C_Texas_LCCN2015630915.jpg",
    "read": "2026-10-01"
};

export default photo;
